<template>
    <header-div
        ref="header"
        v-if="!this.Intro"
        :role="role"
        :username="username"
        @nav-trigger="navTrigger"
    ></header-div>
    <router-view
        ref="chapter"
        :username="username"
    >
    </router-view>
    <!-- 인풋받는 박스 일단은 좀 지워두자. -->
    <Transition>
        <template v-if="!this.Intro && inputUsernameShow">
            <div id="inputbox">
                <div
                    class="username-skip"
                    @click="this.saveName"
                >
                    이름입력 건너뛰기
                </div>
                <Transition>
                    <div
                        v-if="indi2"
                        @click="indi2 = false"
                        class="indicate indicate-2"
                    >
                        <div
                            class="form-background"
                            :style="{
                                backgroundImage: `url(${require(`@/assets/imgs/teaser-background/img_${Math.floor(Math.random() * 100)}.jpg`)})`,
                            }"
                        ></div>
                        <p>인터랙티브 콘텐츠를 통해 소방대원 → 헬기 기장 → 산림청장 → 특수진화대원 → 이재민의 모습을 차례로 경험하실 수 있습니다.</p>
                        <div class="notice">클릭하면 다음으로 이동합니다.</div>
                    </div>
                </Transition>
                <Transition>
                    <div
                        v-if="indi1"
                        @click="indi1 = false"
                        class="indicate indicate-1"
                    >
                        <div
                            class="form-background"
                            :style="{
                                backgroundImage: `url(${require(`@/assets/imgs/teaser-background/img_${Math.floor(Math.random() * 100)}.jpg`)})`,
                            }"
                        ></div>
                        <p>지금부터 당신은 지난 3월 울진 산불 현장으로 들어갈 예정입니다.</p>
                        <div class="notice">클릭하면 다음으로 이동합니다.</div>
                    </div>
                </Transition>
                <div
                    class="form-background"
                    :style="{
                        backgroundImage: `url(${require(`@/assets/imgs/teaser-background/img_${Math.floor(Math.random() * 100)}.jpg`)})`,
                    }"
                ></div>
                <form @submit.prevent>
                    <legend>이름을 입력해주세요</legend>
                    <input
                        type="text"
                        v-model="username"
                    />
                    <button @click="this.saveName">완료</button>
                    <div
                        class="notice"
                        v-show="this.isError"
                    >
                        입력창이 비어있습니다.
                    </div>
                    <div class="notice">이름을 입력해야 넘어갈 수 있습니다.</div>
                </form>
            </div>
        </template>
    </Transition>
    <div
        class="credit"
        v-if="!this.Intro"
    >
        <div class="credit-top">
            <newstapa-logo></newstapa-logo>
            <div class="copy">본 기획물은 정부광고 수수료로 조성된 언론진흥기금의 지원을 받았습니다.</div>
        </div>
        <div class="credit-bottom">
            <template
                v-for="credit in this.credit"
                :key="credit.cat"
            >
                <div class="credit__row">
                    <div class="credit__cat">
                        {{ credit.cat }}
                    </div>
                    <div class="credit__content">
                        {{ credit.content }}
                    </div>
                </div>
            </template>
        </div>
    </div>
    <Transition name="slide-fade">
        <Nav
            v-if="nav.state"
            @nav-close="navClose"
        >
        </Nav>
    </Transition>
</template>

<style lang="scss"></style>
<script>
import 'mapbox-gl/dist/mapbox-gl.css';
import $ from 'jquery';

import HeaderDiv from './components/Header.vue';
import MultiLingual from 'multilingual.js';
import Nav from './components/Nav.vue';
import newstapaLogo from './components/NewstapaLogo.vue';

export default {
    components: {
        HeaderDiv,
        Nav,
        newstapaLogo,
    },
    data() {
        return {
            Intro: false,
            isError: false,
            inputUsernameShow: false,
            indicatorBackgroundImgs: [],
            username: '진실의 수호자',
            role: '',
            indi1: true,
            indi2: true,
            nav: {
                state: false,
            },
            credit: [
                {
                    cat: `기획`,
                    content: `뉴스타파`,
                },
                {
                    cat: `취재`,
                    content: ` 오대양, 조원일, 신동윤, 김새봄, 강혜인
`,
                },
                {
                    cat: `촬영`,
                    content: `이상찬, 신영철, 김기철, 정형민`,
                },
                {
                    cat: `출판`,
                    content: `허현재`,
                },
                {
                    cat: `자료제공`,
                    content: `산림청`,
                },
                {
                    cat: `디자인·개발`,
                    content: `42MXM`,
                },
            ],
        };
    },
    methods: {
        navClose() {
            this.nav.state = false;
        },
        navTrigger() {
            this.nav.state = true;
        },
        randomIndicatorBackground() {
            for (let i = 0; i < 2; i++) {
                this.indicatorBackgroundImgs.push(`./assets/imgs/indicator-background/img_${Math.floor(Math.random() * 10)}.png`);
            }
        },
        saveName() {
            if (this.username == '') {
                this.isError = true;
            } else {
                this.inputUsernameShow = false;
                this.isError = false;
                sessionStorage.setItem('username', this.username);
                window.scrollTo({ top: 0 });
            }
        },
        DoMultiLingual(selector) {
            new MultiLingual({
                containers: document.querySelectorAll(selector),
                configuration: ['ko', 'en', 'num', 'punct'],
            });
        },
        wholeProgress() {
            let basicValue = (this.$route.name - 1) * 20;
            let ratio = ((window.pageYOffset / $('body').height()) * 100) / 5;
            $('.wholeprogressbar').css('width', basicValue + ratio + '%');
        },
        changeRole() {
            if (this.$route.name == 1) {
                this.role = '울진소방서 소방대원';
            }

            if (this.$route.name == 2) {
                this.role = '헬기 기장';
            }

            if (this.$route.name == 3) {
                this.role = '산림청장';
            }

            if (this.$route.name == 4) {
                this.role = '산불특수진화대원';
            }

            if (this.$route.name == 5) {
                this.role = '이재민';
            }
        },
    },
    mounted() {
        addEventListener('scroll', this.wholeProgress, { passive: true });
        this.changeRole();
        this.randomIndicatorBackground();
        this.MultiLingual('.sub-chapter__title h3');
        if (this.$route.name == 'Intro') {
            this.Intro = true;
        } else {
            this.Intro = false;
        }

        if (!sessionStorage.getItem('username')) {
            this.inputUsernameShow = true;
        }
    },
    updated() {
        this.MultiLingual('.sub-chapter__title h3');
    },
    watch: {
        $route(current, past) {
            if (current.name == 'Intro') {
                this.nav.state = false;
                this.Intro = true;
            } else {
                this.Intro = false;
            }
            this.changeRole();
            this.nav.state = false;
        },
    },
};
</script>
<style lang="scss">
.slide-fade-enter-active {
    transition: all 0.5s ease;
}

.slide-fade-leave-active {
    transition: all 0.5s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(100%);
}

.v-leave-active {
    transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.test {
    height: 200vh;
}

.credit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    padding: 30px 20px;
    padding-top: 100px;
    text-align: left;
    background: black;
    color: $white;
    font-size: 0.8em;

    .credit-top {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        svg {
            width: 70px;
            path {
                fill: $white;
            }
        }
    }
    .credit-bottom {
        display: flex;
        gap: 25px;
        border-top: 1px solid rgb(150, 150, 150);
        padding-top: 20px;
        .credit__cat {
            opacity: 0.7;
        }
    }
    &__row {
        display: flex;

        gap: 10px;
    }
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
    display: block;
}
body {
    line-height: 1;
}
ol,
ul {
    list-style: none;
}
blockquote,
q {
    quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
    content: '';
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}

a {
    color: inherit;
    text-decoration: none;
}

* {
    box-sizing: border-box;
}

body {
    font-family: 'Gothic A1', sans-serif;
    font-size: 16px;
}

.ml-ko {
    font-family: 'Gothic A1', sans-serif;
}

.ml-num,
.ml-en,
.ml-punct {
    font-family: miller-display, serif;
    font-size: 1.1em;
    position: relative;
    bottom: 0.03em;
}

::selection {
    background: $red;
    color: $black;
}

body {
    line-height: 1.7;
}

.explain-article {
    background: $white;
    color: $black;
    .sub-chapter__text {
        background: $white;

        background-image: url('@/assets/imgs/back-1.svg');
        background-size: 120%;
    }
}

::-webkit-scrollbar {
    display: none;
}

#inputbox {
    height: 100vh;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    background: $black;
    z-index: 999;
    background-size: 50%;
    background-position: center;
    form {
        display: grid;
        grid-template-columns: 1fr;
        gap: 20px;
        width: 100%;
        max-width: 350px;
        legend {
            text-align: center;
            margin-bottom: 20px;
            background: $white;
            color: $black;
            padding: 10px 20px;
            border: 1px solid gray;
            position: relative;
            z-index: 1;
        }
    }
    input {
        border: 1px solid gray;
        border-radius: 0;
        background: $white;
        color: $black;
        font-size: 20px;
        padding: 10px;
        text-align: center;
        height: 70px;
        border &:focus {
            outline: 0;
        }
        position: relative;
        z-index: 1;
    }
    button {
        color: $white;
        border: 1px solid $white;
        border-radius: 0;
        background: transparent;
        font-size: 20px;
        padding: 5px;
        cursor: pointer;
        position: relative;
        background: $black;
        z-index: 1;
        &:hover {
            background: rgb(40, 40, 40);
        }
    }

    .notice {
        color: $white;
        opacity: 0.5;
        padding: 0;
        text-align: center;
        font-size: 0.8em;
        position: relative;
        z-index: 1;
    }

    .indicate {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        color: $white;
        background: $black;
        z-index: 5;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-x: hidden;
        cursor: pointer;
        background-size: 50%;
        background-position: center;

        .notice {
            position: absolute;
            z-index: 2;
            bottom: 0;
            padding-bottom: 50px !important;
        }
        p {
            max-width: 250px;
            background: black;
            border: 1px solid gray;
            padding: 10px 20px;
            word-break: keep-all;
            text-align: center;
            position: relative;
            z-index: 2;
        }
    }

    .form-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        mix-blend-mode: darken;
        background-size: 50%;
        background-position: center center;
    }
}

.chapter {
    background: $black;
    color: $white;
    overflow-x: hidden;
    &__title {
        font-size: 50px;
        text-align: center;
        // padding-top: 100px;
        height: 100vh;
        &--en {
            font-family: miller-display;
            margin-bottom: 10px;
            font-size: 40px;
            line-height: 1.1;
        }
        &--kr {
            font-weight: 600;
            line-height: 1.1;
        }
        h2 {
            position: absolute;
            top: 100px;
            left: 50%;
            transform: translateX(-50%);
            background: black;
            padding: 10px 20px;
        }
    }
}

.sub-chapter {
    background-image: url('@/assets/imgs/back.svg');
    background-size: 120%;

    background-position: center;
    &__title {
        text-align: center;
        font-size: 30px;
        height: 30vh;
        min-height: 300px;
        padding: 20px;
        word-break: keep-all;
        line-height: 1.3;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__text {
        .p-container {
            margin-bottom: 50px;
            padding: 20px;
        }
        .img-container {
            max-width: 1200px;
            width: 100%;
            margin: 0 auto;
            display: block;
            margin-bottom: 50px;
            img {
                width: 100%;
                aspect-ratio: 1.7;
                &.img-1-1-1 {
                    aspect-ratio: 1.5;
                }
                &.img-1-1-2 {
                    aspect-ratio: 0.75;
                }
            }

            .swiper-slide {
                aspect-ratio: 1.4;
            }
            .caption {
                font-size: 0.8em;
                opacity: 0.5;
                text-align: center;
                padding-top: 15px;
                word-break: keep-all;
            }

            &.img-1-1-2 {
                max-width: 300px;
            }

            .img-group {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 15px;
                img {
                    height: 100%;
                }
            }

            &.img-3-3-1 {
                .img-group {
                    grid-template-columns: 1fr 0.6fr;
                    .square {
                        aspect-ratio: 1;
                    }
                }
            }
        }
        p {
            max-width: 550px;
            margin: 0 auto;
            margin-bottom: 50px;
            word-break: keep-all;
        }

        blockquote {
            max-width: 550px;
            margin: 0 auto;
            padding: 0 30px;
            border-left: 2px solid $white;
            border-right: 2px solid $white;
            margin-bottom: 50px;
            .from {
                padding-top: 10px;
                opacity: 0.5;
                font-size: 0.9em;
                text-align: right;
                font-weight: 400;
            }
        }

        em {
            // font-weight: 700;
            border-bottom: 1px solid $red;
            color: $red;
        }
    }

    .chart-container {
        max-width: 800px;
        width: 100%;
        margin: 0 auto;
        margin-bottom: 50px;
        padding: 20px;
        .caption {
            padding-top: 20px;
            font-size: 0.8em;
            opacity: 0.5;
            text-align: center;
            .box {
                display: inline-block;
                background: $white;
                color: $black;
                padding: 0 5px;
            }
        }
        .chart-title {
            text-align: center;
            font-size: 16px;
            background: $white;
            color: $black;
            max-width: 400px;
            margin: 0 auto;
            margin-bottom: 30px;
        }
        &--pie {
            max-width: 500px;
        }
    }

    .map-container {
        max-width: 1000px;
        width: 100%;
        margin: 0 auto;
        position: relative;
        margin-bottom: 100px;
        .map {
            width: 100%;
            background: $white;
            aspect-ratio: 1.6;
        }
        .caption {
            padding-top: 15px;
            font-size: 0.8em;
            opacity: 0.5;
            text-align: center;
            .box {
                display: inline-block;
                background: $white;
                color: $black;
                padding: 0 10px;
                border-radius: 5px;
            }
        }
        .button-container {
            border-radius: 10px;
            overflow: hidden;
        }
        .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            margin-top: 30px;
            margin-bottom: 15px;
            align-items: flex-end;
            flex-wrap: wrap;
            .button {
                background: $white;
                color: $black;
                border-radius: 10px;
                padding: 0 10px;
                padding-bottom: 10px;
                cursor: pointer;
                box-shadow: inset 0px -10px 0px 0px rgb(140, 140, 140);
                transition: transform 0.2s;

                &.active {
                    transform: translateY(6px);
                }
                &:hover {
                    transform: translateY(6px);
                }
            }
        }

        .map-explain-container {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;

            z-index: 1;
            width: 100%;
            padding: 10px;
            text-align: center;
            .map-explain {
                width: 100%;
                max-width: 400px;
                background: $black;
                color: $white;
                padding: 10px;
                word-break: keep-all;
            }
        }

        .label {
            display: flex;
            gap: 20px;
            justify-content: center;
            font-size: 0.8em;
            margin-top: 10px;
            &__row {
                display: flex;
                align-items: center;
                gap: 10px;
            }
            &__color {
                height: 2px;
                width: 40px;
                &.fire {
                    background: red;
                }
                &.fire-done {
                    background: rgb(0, 255, 255);
                }
            }
        }
    }
    .explain-article__skip {
        position: fixed;
        right: 20px;
        bottom: 20px;
        border: 1px solid $black;
        padding: 5px 10px;
        line-height: 1;
        font-weight: 600;
        background: $white;
        color: $black;
        cursor: pointer;
        transition: background 0.2s;
        &:hover {
            background: rgba(190, 190, 190, 1);
        }
    }

    a {
        text-decoration: underline;
        transition: opacity 0.2s;
        &:hover {
            opacity: 0.5;
        }
    }

    &.explain-article {
        blockquote {
            border-left: 2px solid $black;
            border-right: 2px solid $black;
        }

        .chart-container {
            .chart-title {
                background: $black;
                color: $white;
                max-width: 400px;
                margin: 0 auto;
                margin-bottom: 30px;
            }
        }

        .map-container {
            .buttons {
                display: flex;
                gap: 10px;
                justify-content: center;
                margin-top: 30px;
                margin-bottom: 30px;
                align-items: flex-end;
                .button {
                    background: rgb(210, 210, 210);
                    color: $black;
                    border-radius: 10px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                    cursor: pointer;
                    box-shadow: inset 0px -10px 0px 0px rgb(180, 180, 180);
                }
            }

            .caption {
                .box {
                    display: inline-block;
                    background: rgb(210, 210, 210);
                    color: $black;
                    padding: 0 10px;
                    border-radius: 5px;
                }
            }
        }
    }
}

.move-next-chapter {
    text-align: center;
    background: rgb(30, 30, 30);
    font-size: 30px;
    display: block;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
    line-height: 1.4;
}

.mapboxgl-ctrl-logo,
.mapboxgl-ctrl-bottom-right {
    display: none !important;
}

.username-skip {
    position: fixed;
    bottom: 40px;
    right: 40px;
    z-index: 99;
    background: $black;
    border: 1px solid gray;
    color: rgb(150, 150, 150);
    padding: 5px 15px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
        cursor: pointer;
        background: black;
    }
}

@media all and (max-width: 800px) {
    body {
        font-size: 14px;
    }
    .chapter {
        &__title {
            &--en {
                font-size: 25px;
            }
            &--kr {
                font-size: 30px;
            }

            h2 {
                width: 100%;
                max-width: 250px;
                word-break: keep-all;
            }
        }
    }

    #inputbox {
        height: 100%;
        .indicate {
            height: 100%;
        }
        form {
            max-width: 300px;
            legend {
                margin-bottom: 0;
            }
            input {
                height: 50px;
            }
            button {
                font-size: 16px;
            }
        }
    }

    .sub-chapter {
        padding-bottom: 0;
        &__text {
            .p-container {
                padding-top: 0;
                margin-bottom: 0;
                padding-bottom: 25px;
                p {
                    margin-bottom: 0;
                    margin-bottom: 25px;
                }
            }
            .img-container {
                padding: 20px;
                padding-top: 0;
                padding-bottom: 0;
                margin-bottom: 50px;
                &.gif {
                    width: 50%;
                }
                .caption {
                    padding-top: 8px;
                }

                .img-group {
                    grid-template-columns: 1fr;
                }

                &.img-3-3-1 {
                    .img-group {
                        grid-template-columns: 1fr;
                    }
                }
            }
            .chart-container {
                margin-bottom: 0;
                padding-top: 0;
                margin-bottom: 50px;
            }
        }

        &__title {
            font-size: 25px;
            h3 {
                max-width: 250px;
            }
        }

        &.explain-article {
            padding-bottom: 0;
        }

        .explain-article__skip {
            border-width: 1px;
        }

        .map-container {
            padding: 20px;
            margin-bottom: 25px;
            .map {
                aspect-ratio: 1;
            }

            .map-explain-container {
                top: 0;
                left: 0;
                padding: 30px;
            }
        }
    }

    .move-next-chapter {
        font-size: 23px;
        height: 70vh;
    }

    .credit {
        gap: 100px;
        .copy {
            width: 50%;
            word-break: keep-all;
            text-align: center;
        }
        .credit-bottom {
            flex-direction: column;
            gap: 0;
            width: 100%;
        }
    }

    #inputbox {
        .indicate {
            .notice {
                position: absolute;
                z-index: 2;
                left: 20px;
                bottom: 0;
                padding-bottom: 45px !important;
            }
        }
    }
}
</style>
